<app-header></app-header>

<!-- Middle Content CSS End Here  -->
<div class="middle-content-wrap">
    <!-- Dashboard HTML Start Here  -->
    <div class="globalheading dflex dflex_bet">
        <h2>
            Customers (Total: {{ count || 0 }})
        </h2>
        <div class="addbtnhead">
            <div class="page-header-right">
                <div class="search-merged-container">
                    <select [(ngModel)]="searchBy" class="search-merged-select">
                        <option value="id">ID</option>
                        <option value="name">Name</option>
                        <option value="email">Email</option>
                        <option value="phone">Phone</option>
                    </select>
                    <div class="search-divider"></div>
                    <input class="search-merged-input" placeholder="Search" type="text" id="shares"
                        (keyup.enter)="onEnterEvent($event)" />
                </div>
                <div class="common_btn" style="display: flex;">
                    <button class="filter-btn" (click)="toggleFilters()">
                        <i class="fas fa-filter"></i> Filters
                        <span *ngIf="activeFilterChips.length > 0"
                            class="filter-badge">{{activeFilterChips.length}}</span>
                    </button>
                    <button class="export-btn" (click)="openExportModal()">
                        <img src="assets/images/export.svg" alt="" /> Export
                    </button>
                </div>
            </div>
        </div>
    </div>

    <!-- Shared Filter Component -->
    <app-filter [showFilters]="showFilters" [activeFilterSection]="activeFilterSection"
        [selectedFilters]="selectedFilters" [activeFilterChips]="activeFilterChips" [showNumberOfLikes]="true"
        [religionOptions]="religionOptions" [nationalityOptions]="nationalityOptions"
        [maritalStatusOptions]="maritalStatusOptions" [genderOptions]="genderOptions"
        [interestOptions]="interestOptions" [valueOptions]="valueOptions"
        [alcoholConsumptionOptions]="alcoholConsumptionOptions" [smokingOptions]="smokingOptions"
        [childrenOptions]="childrenOptions" [wakeupAtOptions]="wakeupAtOptions" [hobbiesOptions]="hobbiesOptions"
        [fitnessOptions]="fitnessOptions" [personalityOptions]="personalityOptions"
        [lifeGoalsOptions]="lifeGoalsOptions" [maxionGoalsOptions]="maxionGoalsOptions"
        [meetVibesOptions]="meetVibesOptions" [subscriptionStatusOptions]="subscriptionStatusOptions"
        (toggleFilters)="toggleFilters()" (toggleFilterSection)="toggleFilterSection($event)"
        (updateSingleSelect)="updateSingleSelect($event)" (updateMultiSelect)="updateMultiSelect($event)"
        (applyAgeRangeFilter)="applyAgeRangeFilter($event)" (applyStepRangeFilter)="applyStepRangeFilter($event)"
        (updateNumberInput)="updateNumberInput($event)" (clearFilterChip)="clearFilterChip($event)"
        (clearAllFilters)="clearAllFilters()" (applyFilters)="applyFilters()">
    </app-filter>

    <div class="row pt-3">
        <div class="col pr-1" (click)="isButtonActive('approved')">
            <button type="button" class="add-user-btn tab_btn w-100"
                [ngClass]="(isUserStatus=='approved')? '':'btn_active'">Approved User</button>
        </div>
        <div class="col pl-1 pr-1" (click)="isButtonActive('unapproved')">
            <button type="button" class="add-user-btn tab_btn w-100"
                [ngClass]="(isUserStatus=='unapproved')? '':'btn_active'">Unapproved User</button>
        </div>
        <div class="col pl-1 pr-1" (click)="isButtonActive('auto-approval')">
            <button type="button" class="add-user-btn tab_btn w-100"
                [ngClass]="(isUserStatus=='auto-approval')? '':'btn_active'">Upcoming Auto Approvals</button>
        </div>
        <div class="col pl-1 pr-1" (click)="isButtonActive('auto-rejected')">
            <button type="button" class="add-user-btn tab_btn w-100"
                [ngClass]="(isUserStatus=='auto-rejected')? '':'btn_active'">Auto Rejected Users</button>
        </div>
        <div class="col pl-1 pr-1" (click)="isButtonActive('incomplete')">
            <button type="button" class="add-user-btn tab_btn w-100"
                [ngClass]="(isUserStatus=='incomplete')? '':'btn_active'">Incomplete User</button>
        </div>
        <div class="col pl-1" (click)="isButtonActive('rejected')">
            <button type="button" class="add-user-btn tab_btn w-100"
                [ngClass]="(isUserStatus=='rejected')? '':'btn_active'">Rejected Users</button>
        </div>
    </div>

    <div class="listingformat">
        <div class="tabledatawrap table-responsive">
            <table>
                <thead>
                    <tr>
                        <th>Image</th>
                        <th>Id</th>
                        <th>Username</th>
                        <th>Details</th>
                        <th>Contacts</th>
                        <th *ngIf="isUserStatus=='unapproved'">Social</th>
                        <th *ngIf="isUserStatus=='approved'">Subscription</th>
                        <th *ngIf="isUserStatus=='incomplete'">Step At</th>
                        <th>Action</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor=" let item of (userList | paginate:{id: 'delivered' , itemsPerPage: total, currentPage:
                            p , totalItems: count} );let i=index;">
                        <td>
                            <div class="profile-image"
                                *ngIf="item.profileURL || (item.profileImages && item.profileImages.length > 0)">
                                <img [src]="item.profileURL || item.profileImages[0]"
                                    [alt]="item.name || 'User Profile'" class="user-avatar"
                                    (error)="item.profileURL = null" (click)="openImageModal(item)"
                                    style="width: 60px; height: 60px; object-fit: cover; border-radius: 50%; cursor: pointer;">
                            </div>
                        </td>
                        <td (click)="navigateToCustomerDetail(item.id)" style="cursor: pointer;">{{ item.id}}</td>
                        <td (click)="navigateToCustomerDetail(item.id)" style="cursor: pointer;">{{ item.name || "NA" }}
                        </td>
                        <td>
                            <p>Occupation: {{item?.occupation || 'N/A'}}</p>
                            <p>Nationality: {{item?.nationality || 'N/A'}}</p>
                            <p>Age: {{item?.age || 'N/A'}}</p>
                            <p>Gender: {{item?.gender || 'N/A'}}</p>
                        </td>
                        <td>
                            <p>{{item?.email}}</p>
                            <p>{{item?.countryCode}} {{item?.phone}}</p>
                        </td>
                        <td *ngIf="isUserStatus=='unapproved'"> <a *ngIf="item?.social_url"
                                href="{{formatSocialUrl(item?.social_url)}}" target="_blank" class="btn-dark"
                                style="padding: 4px 8px; border-radius: 4px;">{{item.social_type}}</a>
                            <span *ngIf="!item?.social_url">N/A</span>
                        </td>
                        <td *ngIf="isUserStatus=='approved'">
                            <div style="display: flex; align-items: center; gap: 8px;">
                                {{item.activeSubscription || 'N/A'}}
                                <span *ngIf="item.isScouted && item.activeSubscription"
                                    style="background-color: #76f16c66; color: #02b708; padding: 4px 8px; border-radius: 4px;">Scouted</span>
                            </div>
                        </td>
                        <td *ngIf="isUserStatus=='incomplete'">{{item?.profile_step || 'N/A'}}</td>
                        <td>
                            <div class="action-btns hide-profile-btn">
                                <button (click)="navigateToCustomerDetail(item.id)">
                                    <i class="fa fa-eye" aria-hidden="true"></i>
                                </button>
                                <div *ngIf="isUserStatus=='approved' && !isManager" class="profile-btn">
                                    <button *ngIf="item?.status=='Active'"
                                        (click)="openModal(item?.id,'Block');blockUnblockUser='block'"
                                        data-toggle="modal" data-target="#blockUnblockUser" data-placement="top"
                                        title="Unblocked">
                                        <i class="fa fa-unlock" aria-hidden="true"></i>
                                    </button>

                                    <button *ngIf="item?.status=='Blocked'"
                                        (click)="openModal(item?.id,'Unblock');blockUnblockUser='unblock'"
                                        data-toggle="modal" data-target="#blockUnblockUser" data-placement="top"
                                        title="Blocked">
                                        <i class="fa fa-ban" aria-hidden="true"></i>
                                    </button>
                                </div>
                                <button *ngIf="!isManager"
                                    (click)="openModal(item?.id,'Remove');blockUnblockUser='delete'" data-toggle="modal"
                                    data-target="#blockUnblockUser" data-placement="top" title="Delete">
                                    <i class="fa fa-trash" aria-hidden="true"></i>
                                </button>
                                <button *ngIf="isUserStatus!='unapproved' && isUserStatus!='incomplete' && !isManager"
                                    (click)="openUnapproveModal(item?.id)" data-toggle="modal" data-placement="top"
                                    title="Move user back to waitlist">
                                    <i class="fa fa-undo" aria-hidden="true"></i>
                                </button>
                                <button
                                    *ngIf="(isUserStatus=='unapproved' || isUserStatus=='auto-approval') && !isManager"
                                    (click)="openRejectModal(item?.id)" data-toggle="modal" data-placement="top"
                                    title="Unapprove">
                                    <i class="fa fa-times" aria-hidden="true"></i>
                                </button>

                                <div class="profile-btn" *ngIf="!isManager">
                                    <button
                                        *ngIf="item.registrationCompleted == 'Yes' && (isUserStatus=='unapproved' || isUserStatus=='auto-approval')"
                                        (click)="openApprovedUnapprovedUserModal(item?.id)" tooltip="Approved icon"
                                        data-toggle="modal" data-target="#approveUnapproved">
                                        <i class="fa fa-check-circle"
                                            [ngClass]="(item?.verifyStatus=='No') ? 'pending':(item?.verifyStatus=='Yes' ? 'approved':'unapproved')"></i>
                                    </button>

                                    <button class="profilebtncomplete" *ngIf="item.registrationCompleted == 'No'"
                                        tooltip="Profile Not completed">
                                        Registration not completed
                                    </button>
                                </div>
                            </div>
                        </td>
                    </tr>
                </tbody>
                <tbody *ngIf="userList?.length==0">
                    <tr>
                        <td colspan="12">No Data Found</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="row">
            <div class="col-md-12 custompagination">
                <pagination-controls class="" previousLabel="Prev" nextLabel="Next" id="delivered"
                    (pageChange)="onTableDataChange($event)">
                </pagination-controls>
            </div>
        </div>
    </div>
    <!-- Dashboard HTML End Here  -->
</div>
<!-- Middle Content CSS End Here  -->

<!--Block/Unblock/Delete Popup -->
<div class="modal fade bd-example-modal-sm common_modal" id="blockUnblockUser" tabindex="-1" role="dialog"
    aria-labelledby="myModalLabel" aria-hidden="true">
    <div class="modal-dialog animated fadeInDown">
        <div class="modal-content">
            <div class="modal-header">
                <div class="popupheding">
                    {{blockUnblockUser | titlecase}}
                </div> <button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>
            </div>
            <div class="modal-body">
                <div class="filtercard">
                    <p> Are you sure you want to {{blockUnblockUser}}
                        this user?</p>
                    <div class="common_btn">
                        <button data-dismiss="modal">Cancel</button>
                        <button (click)="blockUnblockDeleteAction()" id="closeM">Yes</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- Delete Popup -->

<!-- Approve modal -->
<app-approve-modal [id]="approveModalId" [modalEvent]="approveEmitter"
    (approveUser)="approveUnapprovedf()"></app-approve-modal>

<!-- TIER 2Approve modal -->
<tier2-app-approve-modal [id]="tier2ApproveModalId" [modalEvent]="tier2ApproveEmitter"
    (approveUser)="approveTier2Unapprovedf()"></tier2-app-approve-modal>

<!-- Reject modal -->
<app-reject-modal [id]="rejectModalId" [modalEvent]="rejectEmitter"
    (rejectUser)="updateUserApproval($event)"></app-reject-modal>

<app-unapprove-modal [id]="unApproveModalId" [modalEvent]="unApproveEmitter"
    (unapproveUser)="updateUserApproval($event)"></app-unapprove-modal>

<!-- Image Zoom Modal -->
<div class="modal fade" id="imageZoomModal" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog modal-lg text-center"
        style="display: flex; align-items: center; justify-content: center; height: 100vh; max-width: 90%;">
        <div class="modal-content"
            style="width: auto; max-width: 100%; background: transparent; border: none; box-shadow: none;">
            <!-- Navigation Buttons (Outside Image) -->
            <button *ngIf="galleryImages.length > 1" (click)="prevImage()" class="btn btn-light"
                style="position: fixed; left: 5%; top: 50%; transform: translateY(-50%); z-index: 1060; border-radius: 50%; width: 50px; height: 50px; font-size: 24px; display: flex; align-items: center; justify-content: center;">
                <i class="fa fa-angle-left"></i>
            </button>
            <button *ngIf="galleryImages.length > 1" (click)="nextImage()" class="btn btn-light"
                style="position: fixed; right: 5%; top: 50%; transform: translateY(-50%); z-index: 1060; border-radius: 50%; width: 50px; height: 50px; font-size: 24px; display: flex; align-items: center; justify-content: center;">
                <i class="fa fa-angle-right"></i>
            </button>

            <!-- Close Button -->
            <button type="button" class="close text-white" data-dismiss="modal" aria-label="Close"
                style="position: fixed; top: 20px; right: 20px; z-index: 1060; font-size: 30px; opacity: 0.8;">
                <span aria-hidden="true">&times;</span>
            </button>

            <div class="modal-body p-0" style="position: relative;">
                <img [src]="selectedImage" class="img-fluid"
                    style="max-height: 90vh; border-radius: 4px; box-shadow: 0 5px 15px rgba(0,0,0,0.5);">
                <div *ngIf="galleryImages.length > 1" class="text-center mt-2 text-white"
                    style="position: absolute; bottom: -30px; width: 100%;">
                    {{ galleryIndex + 1 }} / {{ galleryImages.length }}
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Notification Modal -->
<div class="modal fade bd-example-modal-sm common_modal" id="notificationModal" tabindex="-1" role="dialog"
    aria-labelledby="notificationModalLabel" aria-hidden="true">
    <div class="modal-dialog animated fadeInDown">
        <div class="modal-content">
            <div class="modal-header">
                <div class="popupheding">
                    Send Notification
                </div>
                <button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>
            </div>
            <div class="modal-body">
                <div class="filtercard">
                    <div class="form-group">
                        <label for="notificationTitle">Notification Title *</label>
                        <input type="text" class="form-control" id="notificationTitle" [(ngModel)]="notificationTitle"
                            placeholder="Enter notification title" required>
                    </div>
                    <div class="form-group">
                        <label for="notificationMessage">Notification Message *</label>
                        <textarea class="form-control" id="notificationMessage" rows="4"
                            [(ngModel)]="notificationMessage" placeholder="Enter notification message"
                            required></textarea>
                    </div>
                    <div class="common_btn">
                        <button data-dismiss="modal">Cancel</button>
                        <button (click)="sendNotification()"
                            [disabled]="!notificationTitle || !notificationMessage">Send</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Export Modal -->
<div class="modal fade bd-example-modal-lg common_modal" id="exportModal" tabindex="-1" role="dialog"
    aria-labelledby="exportModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg animated fadeInDown">
        <div class="modal-content">
            <div class="modal-header">
                <div class="popupheding">
                    Export Data
                </div>
                <button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>
            </div>
            <div class="modal-body">
                <div class="filtercard">
                    <p>Select the fields you want to include in the export:</p>
                    <div class="row">
                        <div class="col-md-6">
                            <div class="form-check mb-2" *ngFor="let field of getFirstHalfFields(); let i = index">
                                <input class="form-check-input" type="checkbox" [id]="'exportField_' + field.key"
                                    [checked]="selectedExportFields.includes(field.key)"
                                    (change)="toggleExportField(field.key)">
                                <label class="form-check-label" [for]="'exportField_' + field.key">
                                    {{ field.label }}
                                </label>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-check mb-2" *ngFor="let field of getSecondHalfFields(); let i = index">
                                <input class="form-check-input" type="checkbox" [id]="'exportField_' + field.key"
                                    [checked]="selectedExportFields.includes(field.key)"
                                    (change)="toggleExportField(field.key)">
                                <label class="form-check-label" [for]="'exportField_' + field.key">
                                    {{ field.label }}
                                </label>
                            </div>
                        </div>
                    </div>
                    <div class="mt-3">
                        <button type="button" class="btn btn-sm btn-secondary" (click)="selectAllExportFields()">
                            Select All
                        </button>
                        <button type="button" class="btn btn-sm btn-outline-secondary ml-2"
                            (click)="clearAllExportFields()">
                            Clear All
                        </button>
                    </div>
                    <div class="common_btn mt-4">
                        <button data-dismiss="modal">Cancel</button>
                        <button style="width: auto;" (click)="exportWithSelectedFields()"
                            [disabled]="selectedExportFields.length === 0">
                            Export ({{ selectedExportFields.length }} fields)
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>